import * as React from 'react';
import { TFunction, useTranslation } from 'react-i18next';

import Skeleton from 'antd/lib/skeleton';
import Typography from 'antd/lib/typography';

import { Nullable } from '@common/typescript/objects/Nullable';

import { DeliveryType, DeliveryTypeName } from '@app/objects/Pet';
import { useCrematoryFeatures } from '@app/hooks/Crematory/useCrematoryFeatures';
import { useDeliveryTypes } from '@app/hooks/Delivery/useDeliveryTypes';
import { CrematoryFeatures } from '@app/objects/CrematoryFeatures';
import { DeliveryTypeEntity } from '@app/objects/DeliveryType';

interface DeliveryTypeRecord {
	deliveryType: DeliveryType;
	deliveryTypeId?: Nullable<number>;
}

interface OwnProps {
	value: DeliveryTypeRecord;
}

interface GetTextConfig {
	t: TFunction;
	features: Nullable<CrematoryFeatures>;
	types: Map<number, DeliveryTypeEntity>;
}

function getDeliveryTypeName(type: DeliveryType, t: TFunction): string {
	return t(`enums.delivery-type.${DeliveryTypeName[DeliveryType[type]]}`);
}

const unknownType: string = 'Unknown Delivery Type';
function getText(record: DeliveryTypeRecord, config: GetTextConfig): string {
	if (!config.features?.enableCustomDeliveryType) return getDeliveryTypeName(record.deliveryType, config.t);

	if (!record.deliveryTypeId) return 'None';
	const type = config.types.get(record.deliveryTypeId);

	return type?.name ?? unknownType;
}

export const DeliveryTypeView: React.FC<OwnProps> = (props: OwnProps) => {
	const { t } = useTranslation();
	const features = useCrematoryFeatures();
	const types = useDeliveryTypes();
	const loading = features.isLoading || types.loading;
	const text = getText(props.value, { features: features.item, types: types.map, t });

	return (
		<div>
			{
				loading
					? (
						<Skeleton
							paragraph={{
								rows: 1,
								style: {
									margin: 0,
								},
							}}
							title={false}
						/>
					) : (
						<Typography.Text>
							{text}
						</Typography.Text>
					)
			}
		</div>
	);
};
